import { initializeModal } from "../Shared/Modal/modal";

const treatmentList = document.getElementById("treatment-list");

if (!treatmentList) {
  throw "Treatment list missing";
}

const treatmentListForm = treatmentList.querySelector<HTMLElement>("form");

if (!treatmentListForm) {
  throw "Treatment list form missing";
}

const filterDropdowns = document.querySelectorAll<HTMLElement>("[data-filter-dropdown]");

filterDropdowns.forEach(filterDropdown => {
  const select = filterDropdown.querySelector("select");

  if (select) {
    select.addEventListener("change", async _ => {
      // Submit the form whenever a filter is updated
      const event = new Event("submit");

      treatmentListForm.dispatchEvent(event);
    });
  }
});

// Initialize new modals from search results
htmx.onLoad(rootElement => {
  rootElement
    .querySelectorAll<HTMLElement>("[data-modal]")
    .forEach(modal => initializeModal(modal));
});
